import {css, html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators';
import {normalizeStyles} from "@webs/components-library/theming";

@customElement('webs-logo')
export class Logo extends LitElement {

  static styles = [
    normalizeStyles,
    css`
    .logo.logo--normal {
      background: var(--color.white);
      display: block;
      height: 36px;
      padding: 0px 1.6rem;
    }

    .logo.logo--small {
      display: flex;
      height: 43px;
      width: auto;
      justify-content: center;
      padding: .6rem .8rem;
    }

    .logo img {
      display: block;
      max-height: 100%;
      object-fit: contain;
      width: auto;
    }

    `
  ];

  @property()
  href: string;

  @property({attribute: 'src'})
  imageSrc: string;

  @property({attribute: 'alt'})
  imageAlt: string;

  @property({attribute: 'size'})
  imageSize = 'normal';

  @property({attribute: 'new-tab', type: Boolean})
  openInNewTab = false;

  @property()
  width: string

  protected render(): unknown {
    return html`
      ${this.href ? html`
        <a part="logo" class="logo logo--${this.imageSize}" href="${this.href}" target="${this.openInNewTab ? '_blank' : ''}">
          <img src="${this.imageSrc}" alt="${this.imageAlt}" width="${this.width}" loading="lazy">
        </a>
      ` : html `
        <picture part="logo" class="logo logo--${this.imageSize}">
          <img src="${this.imageSrc}" alt="${this.imageAlt}" width="${this.width}" loading="lazy">
        </picture>
      `}
    `;
  }
}
